import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

const STEPS = [
  { id: 'upload', label: 'Upload' },
  { id: 'review', label: 'Review' },
] as const;

interface StepIndicatorProps {
  currentStep: 'upload' | 'analyzing' | 'review';
}

export function StepIndicator({ currentStep }: StepIndicatorProps) {
  const activeIndex = currentStep === 'upload' ? 0 : 1;

  return (
    <div className="flex items-center gap-2">
      {STEPS.map((step, i) => {
        const isCompleted = i < activeIndex;
        const isActive = i === activeIndex;

        return (
          <div key={step.id} className="flex items-center gap-2">
            {i > 0 && (
              <div
                className={cn(
                  'h-px w-8 transition-colors',
                  isCompleted || isActive ? 'bg-blue-500' : 'bg-gray-200',
                )}
              />
            )}
            <div
              className={cn(
                'flex items-center gap-1.5 text-xs font-medium',
                isCompleted || isActive ? 'text-blue-600' : 'text-gray-400',
              )}
            >
              <span
                className={cn(
                  'w-5 h-5 rounded-full flex items-center justify-center text-xs font-semibold',
                  isCompleted && 'bg-blue-600 text-white',
                  isActive && 'border-2 border-blue-600 text-blue-600',
                  !isCompleted && !isActive && 'border-2 border-gray-300 text-gray-400',
                )}
              >
                {isCompleted ? <Check size={10} /> : i + 1}
              </span>
              {step.label}
            </div>
          </div>
        );
      })}
    </div>
  );
}
